module.exports = __webpack_public_path__ + "img/8xiao.4c529742.png";